import { useState, useEffect } from 'react';

const BANNER_KEY = 'toolnova_top_banner_dismissed';

export default function TopBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(BANNER_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(BANNER_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="w-full bg-gradient-to-r from-[#0d9488] via-[#14b8a6] to-[#0d9488] text-white py-2.5 px-4 flex items-center justify-center relative shadow-md shadow-teal-900/30 z-50">
      <p className="text-sm font-medium text-center leading-snug">
        Discover 150+ AI Tools — Free, No Signup Required
      </p>
      <button
        onClick={dismiss}
        aria-label="Dismiss banner"
        className="absolute right-4 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/25 transition-colors cursor-pointer flex-shrink-0"
      >
        <i className="ri-close-line text-base"></i>
      </button>
    </div>
  );
}
